export const toObject = entries => entries.reduce((obj, entry) => {
  const [key, value] = entry;
  obj[key] = value;
  return obj;
}, {});

export const has = (obj, key) => key in obj;